import styled from 'styled-components';
import { palette } from 'styled-theme';
import { WithDirection } from '@jjj/components';

const Wrapper = styled('div')`
  .organization-logos {
    display: flex;

    .logo {
      height: 20px;
      width: 20px;
      margin: 0;
      border-radius: 50%;

      + .logo {
        margin-left: -4px;
      }
    }
  }

  .funnel-wrapper {
    padding: 80px 0 0 19px !important;
    padding: ${props => (props['data-rtl'] === 'rtl' ? '80px 19px 0 0' : '80px 0 0 19px')} !important;

    .segment-tooltip-value {
      width: 100%;
      text-align: center;
    }
  }

  .ant-table tr.selected-row {
    background-color: ${palette('primary', 1)} !important;
  }

  .info-icon {
    margin-left: 4px;
    cursor: pointer;

    svg * {
      color: ${palette('info', 0)};
    }
  }
`;

export const LightText = styled('span')`
  font-weight: normal;
`;

const OrganizationsTooltipWrapperStyles = styled.div`
  display: flex;

  .organization-item {
    display: flex;
    align-items: center;

    :first-child {
      margin-right: 6px;
    }

    .text {
      font-size: 10px;
      font-weight: bold;
      margin-left: ${props => (props['data-rtl'] === 'rtl' ? 'auto' : '4px')};
      margin-right: ${props => (props['data-rtl'] === 'rtl' ? '4px' : 'auto')};
    }
  }

  .logo {
    height: 16px;
    width: 16px;
    margin: 0;
    border-radius: 50%;
  }
`;

const OrganizationsTooltipWrapper = WithDirection(OrganizationsTooltipWrapperStyles);

export { OrganizationsTooltipWrapper };

export default WithDirection(Wrapper);
